export class BerekendClass {
  opdrachtUuid?: string;
  opdrachtStatus?: string;
  isBerekend?: boolean;

  constructor();
  constructor(opdrachtUuid: string, opdrachtStatus: string, isBerekend: boolean);
  constructor(opdrachtUuid?: string, opdrachtStatus?: string, isBerekend?: boolean) {
    this.opdrachtUuid = opdrachtUuid ?? "";
    this.opdrachtStatus = opdrachtStatus ?? "";
    this.isBerekend = isBerekend ?? false;
  }
}